import type { AssistantStatus } from '@/types/api';
import { useApi } from '@/utils/use-api';

/** Assistant's state (ASSIST-1): whether it is on here (prisma-assistant), and its account. */
export const useAssistant = () => useApi<AssistantStatus>('/assistant');

/** The message of a refused request, as the backend gives it. */
export const errorOf = (err: unknown, fallback = 'Something went wrong. Try again.') =>
  (err as { response?: { data?: { error?: string } } }).response?.data?.error ?? fallback;
